export default {
  call: 'Call',
  text: 'Text',
}
